import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { hasRunNowPermission } from '~src/app/utils/MixedContentHelpers';
import { areLinkedTasksEnabled } from '~src/linkedTasks/utils/LinkedTaskHelpers';

import { Messages } from '../../../../codegen/Localize';
import { RunFlowTaskInfo } from '../../../../ts/models/RunFlowTaskInfo';
import { runFlowTaskRunNow } from '../../../actions/spaces/RunFlowTaskMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowTaskRunNowAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.runNow_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[], state: AppState) => {
    const runNowPermission = hasRunNowPermission(state);
    if (areLinkedTasksEnabled()) {
      const hasLinkedTask = targetItems.find((item) => item.taskType === 'LinkedTask') !== undefined;
      const linkedTaskRunNowPermission = SessionSiteSelectors.isLinkedTaskRunNowEnabledOnSiteEnabled(state);
      if (hasLinkedTask) {
        return targetItems.length > 0 && runNowPermission && linkedTaskRunNowPermission;
      }
    }
    return targetItems.length > 0 && runNowPermission;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskRunNow(targetItems)
};
